(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-banner"] && !Shopify.designMode) return;
  try {
    
  /* Progresso di ingresso nel viewport → variabile --p usata dal clip-path (0 tutta larghezza, 1 contenitore). */
  class CommunityReveal extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('community--static') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }
    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh - rect.top) / (vh * 0.75)));
      this.style.setProperty('--p', p.toFixed(3));
    }
  }
  customElements.define('community-reveal', CommunityReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-pair"] && !Shopify.designMode) return;
  try {
    
  /* Parallasse: ogni immagine trasla di (scroll percorso × velocità); velocità negativa = sale più in fretta della pagina. */
  class ImagePair extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.items = [...this.querySelectorAll('.image-pair__item')];
      this.speeds = [(parseFloat(this.getAttribute('data-speed-1')) || 0) / 100, (parseFloat(this.getAttribute('data-speed-2')) || 0) / 100];
      this.offsets = [parseFloat(this.getAttribute('data-offset-1')) || 0, parseFloat(this.getAttribute('data-offset-2')) || 0];
      this.items.forEach((el, i) => (el.style.transform = `translateY(${this.offsets[i]}px)`));
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }
    update() {
      const rect = this.getBoundingClientRect();
      if (rect.top > window.innerHeight + 50 || rect.bottom < -200) return;
      // scroll percorso da quando la sezione è entrata nel viewport (0 se è visibile già al caricamento)
      const docTop = rect.top + window.scrollY;
      const delta = Math.max(0, window.scrollY - Math.max(0, docTop - window.innerHeight));
      this.items.forEach((el, i) => {
        el.style.transform = `translateY(${(this.offsets[i] + delta * this.speeds[i]).toFixed(1)}px)`;
      });
    }
  }
  customElements.define('image-pair', ImagePair);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explorer"] && !Shopify.designMode) return;
  try {
    
  class ProductExplorer extends HTMLElement {
    connectedCallback() {
      this.scenes = [...this.querySelectorAll('[data-explorer-scene]')];
      this.cards = [...this.querySelectorAll('[data-explorer-to]')];
      this.buys = [...this.querySelectorAll('[data-explorer-buy]')];
      this.index = 0;
      if (this.scenes.length < 2) return;
      this.querySelector('[data-explorer-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-explorer-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.cards.forEach((c) => c.addEventListener('click', () => this.go(parseInt(c.dataset.explorerTo, 10))));
      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => {
          if (!this.matches(':hover')) this.go(this.index + 1);
        }, 6000);
      }
    }
    go(i) {
      const n = this.scenes.length;
      const next = ((i % n) + n) % n;
      const forward = next > this.index || (this.index === n - 1 && next === 0);
      this.cards.forEach((c, k) => {
        c.classList.toggle('is-active', k === next);
        c.classList.toggle('is-before', k === this.index && forward);
        c.setAttribute('aria-pressed', String(k === next));
      });
      this.scenes.forEach((s, k) => {
        s.classList.toggle('is-active', k === next);
        s.setAttribute('aria-hidden', String(k !== next));
      });
      this.buys.forEach((b, k) => (b.hidden = k !== next));
      this.index = next;
    }
  }
  customElements.define('product-explorer', ProductExplorer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivenditori-index"] && !Shopify.designMode) return;
  try {
    
  class DealersDirectory extends HTMLElement {
    connectedCallback() {
      this.region = this.querySelector('[data-dealers-region]');
      this.province = this.querySelector('[data-dealers-province]');
      this.search = this.querySelector('[data-dealers-search]');
      this.items = [...this.querySelectorAll('.dealers__item')];
      this.count = this.querySelector('[data-dealers-count]');
      this.empty = this.querySelector('[data-dealers-empty]');
      this.provinceOptions = [...this.province.options];
      [this.region, this.province].forEach((el) => el.addEventListener('change', () => this.filter()));
      this.search.addEventListener('input', window.themeDebounce(() => this.filter(), 150));
      this.region.addEventListener('change', () => {
        const reg = this.region.value;
        this.provinceOptions.forEach((o) => (o.hidden = !!reg && !!o.value && o.dataset.region !== reg));
        if (reg && this.province.selectedOptions[0]?.hidden) this.province.value = '';
        this.filter();
      });
    }
    filter() {
      const reg = this.region.value;
      const prov = this.province.value;
      const q = this.search.value.trim().toLowerCase();
      let n = 0;
      this.items.forEach((el) => {
        const ok = (!reg || el.dataset.region === reg) && (!prov || el.dataset.province === prov) && (!q || el.dataset.text.includes(q));
        el.hidden = !ok;
        if (ok) n++;
      });
      const tpl = n === 1 ? this.count.dataset.one : this.count.dataset.other;
      this.count.textContent = tpl.replace(/\d+/, n);
      this.empty.hidden = n > 0;
    }
  }
  customElements.define('dealers-directory', DealersDirectory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal-video"] && !Shopify.designMode) return;
  try {
    
  class ScrollReveal extends HTMLElement {
    connectedCallback() {
      this.phases = [...this.querySelectorAll('[data-phase]')];
      this.count = this.phases.length;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
      const video = this.querySelector('video');
      if (video) {
        new IntersectionObserver((entries) => entries.forEach((e) => (e.isIntersecting ? video.play?.().catch(() => {}) : video.pause?.())), { threshold: 0.05 }).observe(this);
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
    onScroll() {
      const rect = this.getBoundingClientRect();
      const total = this.offsetHeight - window.innerHeight;
      const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, total)));
      const active = Math.min(this.count - 1, Math.floor(progress * this.count + 0.0001));
      this.phases.forEach((p, i) => {
        p.classList.toggle('is-active', i === active);
        p.classList.toggle('is-past', i < active);
      });
      this.classList.toggle('is-final', active === this.count - 1);
    }
  }
  customElements.define('scroll-reveal', ScrollReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideshowElement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.slideTo, 10))));
      this.track.addEventListener('scroll', window.themeDebounce(() => this.sync(), 80), { passive: true });
      const pause = this.querySelector('[data-slideshow-pause]');
      pause?.addEventListener('click', () => {
        this.paused = !this.paused;
        pause.setAttribute('aria-pressed', String(this.paused));
      });
      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const ms = (parseInt(this.dataset.interval, 10) || 5) * 1000;
        this.timer = setInterval(() => {
          if (!this.paused && !this.hover && document.visibilityState === 'visible') this.go(this.index + 1);
        }, ms);
        this.addEventListener('mouseenter', () => (this.hover = true));
        this.addEventListener('mouseleave', () => (this.hover = false));
        this.addEventListener('focusin', () => (this.hover = true));
        this.addEventListener('focusout', () => (this.hover = false));
      }
    }
    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.track.clientWidth * this.index, behavior: 'smooth' });
      this.render();
    }
    sync() {
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index) {
        this.index = i;
        this.render();
      }
    }
    render() {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      this.dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === this.index);
        d.setAttribute('aria-selected', String(i === this.index));
      });
    }
  }
  customElements.define('slideshow-element', SlideshowElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bento"] && !Shopify.designMode) return;
  try {
    
  /* Contatori: il numero conta da 0 al valore quando la tile entra nel viewport, conservando prefisso/suffisso,
     decimali e separatore delle migliaia ("1.8M+", "900K+", "44%", "5.000+"); testi senza cifre restano fissi. */
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const parse = (text) => {
      const m = text.match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
      if (!m) return null;
      const [, pre, num, post] = m;
      const dec = num.match(/([.,])(\d{1,2})$/);
      const decimals = dec ? dec[2].length : 0;
      const sep = dec ? dec[1] : '';
      const thousands = dec ? '' : (num.match(/[.,]/) || [''])[0];
      const clean = dec ? num.slice(0, -(decimals + 1)).replace(/[.,]/g, '') + '.' + dec[2] : num.replace(/[.,]/g, '');
      const value = parseFloat(clean);
      return Number.isFinite(value) && value > 0 ? { pre, post, value, decimals, sep, thousands } : null;
    };
    const format = (p, v) => {
      let s = v.toFixed(p.decimals);
      if (p.decimals) s = s.replace('.', p.sep);
      if (p.thousands) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, p.thousands);
      return p.pre + s + p.post;
    };
    const run = (el) => {
      const p = parse(el.textContent.trim());
      if (!p) return;
      const duration = 1600;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = format(p, p.value * eased);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        run(en.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.stats__number').forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  class VideoShowcase extends HTMLElement {
    connectedCallback() {
      this.stages = [...this.querySelectorAll('[data-showcase-stage]')];
      this.thumbs = [...this.querySelectorAll('[data-showcase-thumb]')];
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.select(parseInt(t.dataset.showcaseThumb, 10))));
      this.querySelectorAll('[data-showcase-play]').forEach((b) => b.addEventListener('click', () => this.play(b.closest('[data-showcase-stage]'))));
    }
    select(i) {
      this.stages.forEach((s, k) => {
        s.hidden = k !== i;
        s.classList.toggle('is-active', k === i);
        if (k !== i) this.stop(s);
      });
      this.thumbs.forEach((t, k) => {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-pressed', String(k === i));
      });
    }
    embed(url) {
      const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
      if (yt) return `<iframe src="https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&playsinline=1" title="YouTube video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
      const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return `<iframe src="https://player.vimeo.com/video/${vm[1]}?autoplay=1" title="Vimeo video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
      return `<video src="${url}" controls autoplay playsinline></video>`;
    }
    play(stage) {
      const player = stage.querySelector('[data-showcase-player]');
      if (!player) return;
      if (player.hasAttribute('data-shopify-video')) {
        const tpl = player.querySelector('template');
        player.innerHTML = tpl ? tpl.innerHTML : '';
        player.querySelector('video')?.play?.().catch(() => {});
      } else if (player.dataset.videoUrl) {
        player.innerHTML = this.embed(player.dataset.videoUrl);
      } else {
        return;
      }
      player.hidden = false;
      stage.querySelector('[data-showcase-play]').hidden = true;
    }
    stop(stage) {
      const player = stage.querySelector('[data-showcase-player]');
      if (!player || player.hidden) return;
      const tpl = player.querySelector('template');
      player.innerHTML = tpl ? tpl.outerHTML : '';
      player.hidden = true;
      stage.querySelector('[data-showcase-play]').hidden = false;
    }
  }
  customElements.define('video-showcase', VideoShowcase);

  } catch(e) { console.error(e); }
})();
})();
